import React, { useEffect, useMemo, forwardRef, useImperativeHandle, Ref, useState } from "react";
import { Row, Col, Form, FormInstance } from "antd";
import Text from "../../../components/Text/Text";
import Input from "../../../components/Input/Input";
import icon from "../../../resource/icon";
import { numberFormatter } from "../../../utility/Formatter";
import { NumberNotZero, handleNumberOnlyCopyPaste } from "../../../utility/validator";
import color from "../../../resource/color";

interface Props {
  isSpecial: boolean;
  isLimitedOrder?: boolean;
  marketPrice?: number;
  saleUOMTH?: string;
  keyNameSpecialPrice?: any;
  keyNameLimitQty?: any;
  isDetail?: boolean;
  form2?: FormInstance;
}

const RenderSpecialContentDup = ({
  isSpecial,
  marketPrice,
  isLimitedOrder,
  saleUOMTH,
  keyNameSpecialPrice,
  keyNameLimitQty,
  isDetail,
  form2,
}: Props) => {
  const _watchSpecialPrice = Form.useWatch(keyNameSpecialPrice, form2);

  const renderSpecialPrice = () => (
    <Row gutter={20} align='middle' justify='center' style={{ alignItems: "start" }}>
      <Col span={6} className='form-label-col' style={{ display: "flex", alignItems: "start" }}>
        <img src={icon.PriceTag} style={{ width: 22, height: 22 }} alt='discount' />
        <Text fontWeight={700} fontSize={14}>
          ราคาพิเศษที่ลด
        </Text>
      </Col>
      <Col span={4}>
        <Form.Item
          name={keyNameSpecialPrice}
          rules={[
            { required: true, message: "โปรดระบุราคาที่ลด" },
            {
              validator(rule, value, callback) {
                if (Number(marketPrice) - Number(form2?.getFieldValue(keyNameSpecialPrice)) < 0) {
                  return Promise.reject(new Error(`ราคาพิเศษที่ลดไม่สามารถมากกว่าราคาขาย`));
                }
                return Promise.resolve();
              },
            },
          ]}
          noStyle
        >
          <Input
            disabled={isDetail}
            style={{ color: color.BK }}
            autoComplete='off'
            onKeyDown={handleNumberOnlyCopyPaste}
            placeholder='ระบุราคาที่ลด'
            suffix={<Text fontFamily='Sarabun'>บาท</Text>}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item className='form-item-error-sm' style={{ width: "65%" }}>
          <Input disabled value={saleUOMTH} style={{ color: color.BK }} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Text fontSize={12} fontFamily='Sarabun'>
          ราคาหลังหักส่วนลด
        </Text>
        <br />
        <Text fontWeight={600} fontFamily='Sarabun' style={{ color: color.BK }} disabled={isDetail}>
          {numberFormatter(
            Number(marketPrice) - Number(form2?.getFieldValue(keyNameSpecialPrice) || 0),
            2,
          )}{" "}
          บาท/
          {saleUOMTH}
        </Text>
      </Col>
    </Row>
  );
  const renderLimitedOrder = () => (
    <Row gutter={20} align='middle' justify='center' style={{ marginTop: isSpecial ? 16 : 12 }}>
      <Col span={6} className='form-label-col' style={{ display: "flex", alignItems: "start" }}>
        <img src={icon.ProductBox} style={{ width: 22, height: 22 }} alt='limited' />
        <Text fontWeight={700} fontSize={14}>
          จำกัดจำนวนซื้อ / คำสั่งซื้อ
        </Text>
      </Col>
      <Col span={4}>
        <Form.Item
          style={{ marginBottom: 0 }}
          name={keyNameLimitQty}
          rules={[{ required: true, message: "โปรดระบุจำนวนสินค้า" }]}
          noStyle
        >
          <Input
            disabled={isDetail}
            style={{ color: color.BK }}
            autoComplete='off'
            onKeyDown={handleNumberOnlyCopyPaste}
            placeholder='ระบุจำนวน'
            suffix={<Text fontFamily='Sarabun'>{saleUOMTH}</Text>}
          />
        </Form.Item>
      </Col>
      <Col span={6} />
      <Col span={6} />
    </Row>
  );

  return (
    <div
      style={{
        padding: isSpecial || isLimitedOrder ? "10px" : "0px",
        backgroundColor: color.white,
      }}
    >
      {isSpecial && renderSpecialPrice()}
      {isLimitedOrder && renderLimitedOrder()}
    </div>
  );
};

export default RenderSpecialContentDup;
